// extracted by mini-css-extract-plugin
module.exports = {"userDetailTitle":"SelectDropdown_userDetailTitle__1sClw","error":"SelectDropdown_error__2zKNF","dropdown":"SelectDropdown_dropdown__Ybn2c"};